import React from 'react';
import {
  DefaultActions,
  ReportActionsPropsUnion,
  ReportActionsTopBarContainer,
} from './components';

export function ReportActionsTopBar({
  children,
  reportData,
  reportPermaLink,
  reportType,
  reportTitle,
  deleteCurrentReport,
  reportUpgraded,
  additionalActions,
}: ReportActionsPropsUnion) {
  return (
    <ReportActionsTopBarContainer>
      {reportPermaLink && reportType && reportTitle ? (
        <DefaultActions
          isInReport
          reportData={reportData}
          reportPermaLink={reportPermaLink}
          reportType={reportType}
          reportTitle={reportTitle}
          deleteCurrentReport={deleteCurrentReport}
          reportUpgraded={reportUpgraded}
          additionalActions={additionalActions}
        />
      ) : (
        <>{children}</>
      )}
    </ReportActionsTopBarContainer>
  );
}
